/**
 * True for a client-side fetch error that means "you are not authenticated" — an HTTP 401 from an
 * RTK Query endpoint, or the shape the throwing `apiFetch` produces (fetchBaseQuery reports a thrown
 * fetchFn error as a FETCH_ERROR carrying AuthError's message, with no status).
 *
 * Used both to word the error a viewer sees and to decide whether to send a signed-out visitor to
 * sign-in (see useSignInOnUnauthorized), so it is deliberately narrow: a 403 is a real access denial
 * for a signed-in user and must NOT be mistaken for it.
 */
export function isUnauthorizedError(error: unknown): boolean {
  if (typeof error !== 'object' || error === null) return false
  if ('status' in error && (error as { status?: unknown }).status === 401) return true
  const message = (error as { error?: unknown }).error
  return typeof message === 'string' && message.includes('Authentication required')
}
